<template>
  <section
    id="card-text-alignment"
  >
    <b-overlay
      id="overlay-background"
      :show="loader === true || generalLoader === true"
      variant="dark"
      opacity="0.85"
      blur="2px"
      rounded="sm"
      spinner-variant="primary"
      spinner-medium
    >
      <b-row
        class="content-header"
      >
        <!-- Content Left -->
        <b-col
          class="content-header-left mb-2"
          cols="12"
          md="9"
        >
          <b-row class="breadcrumbs-top">
            <b-col cols="12">
              <h2 class="content-header-title float-left pr-1 mb-0">
                {{ $t('DEBTIA_VIEW_CASE') }}
              </h2>
              <div class="breadcrumb-wrapper">
                <b-breadcrumb>
                  <b-breadcrumb-item to="/cases">
                    <feather-icon
                      icon="HomeIcon"
                      size="16"
                      class="align-text-top"
                    />
                  </b-breadcrumb-item>
                  <b-breadcrumb-item active>
                    {{ caseDetailsData.id }} (BC-ID: {{ caseDetailsData.bc_case_id }})
                  </b-breadcrumb-item>
                </b-breadcrumb>
              </div>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <b-col
        v-if="isBlur"
        md="12"
        lg="12"
      >
        <b-card
          v-if="caseDetailsData.status === 2"
          class="text-right"
        >
          <b-row>
            <b-col
              class="text-left"
              md="6"
              lg="6"
            >
              <h6>
                BC CASE ID: <span class="code text-red">{{ caseDetailsData.bc_case_id }}</span>
                <span
                  v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                  variant="outline-primary"
                  class="btn-icon rounded-circle copy-btn ml-1"
                  @click.stop.prevent="copyCode('copy-bc-case-id')"
                >
                  <feather-icon
                    size="18"
                    :icon="'CopyIcon'"
                  />
                </span>
                <input
                  id="copy-bc-case-id"
                  type="hidden"
                  :value="caseDetailsData.bc_case_id"
                >
              </h6>
              <h6 class="mb-0">
                CASE ID: <span class="code text-red">{{ caseDetailsData.id }}</span>
                <span
                  v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                  variant="outline-primary"
                  class="btn-icon rounded-circle copy-btn ml-1"
                  @click.stop.prevent="copyCode('copy-case-id')"
                >
                  <feather-icon
                    size="18"
                    :icon="'CopyIcon'"
                  />
                </span>
                <input
                  id="copy-case-id"
                  type="hidden"
                  :value="caseDetailsData.id"
                >
              </h6>
            </b-col>
            <b-col
              class="text-right"
              md="6"
              lg="6"
            >
              <h6
                id="popover-reactive-4"
                ref="button"
                v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                variant="outline-primary"
                class="transaction-title pointer-name"
                @mouseover="setStatePopup(caseStateData)"
              >
                {{ $t('DEBTIA_DECLINED') }}
              </h6>
              <div><small>{{ caseStateData.reason }}</small></div>
            </b-col>
          </b-row>
        </b-card>
        <b-card
          v-if="caseDetailsData.status === 3"
          class="text-right"
        >
          <b-row>
            <b-col
              class="text-left"
              md="6"
              lg="6"
            >
              <h6>
                BC CASE ID: <span class="code text-red">{{ caseDetailsData.bc_case_id }}</span>
                <span
                  v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                  variant="outline-primary"
                  class="btn-icon rounded-circle copy-btn ml-1"
                  @click.stop.prevent="copyCode('copy-bc-case-id')"
                >
                  <feather-icon
                    size="18"
                    :icon="'CopyIcon'"
                  />
                </span>
                <input
                  id="copy-bc-case-id"
                  type="hidden"
                  :value="caseDetailsData.bc_case_id"
                >
              </h6>
              <h6 class="mb-0">
                CASE ID: <span class="code text-red">{{ caseDetailsData.id }}</span>
                <span
                  v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                  variant="outline-primary"
                  class="btn-icon rounded-circle copy-btn ml-1"
                  @click.stop.prevent="copyCode('copy-case-id')"
                >
                  <feather-icon
                    size="18"
                    :icon="'CopyIcon'"
                  />
                </span>
                <input
                  id="copy-case-id"
                  type="hidden"
                  :value="caseDetailsData.id"
                >
              </h6>
            </b-col>
            <b-col
              class="text-right"
              md="6"
              lg="6"
            >
              <h6
                id="popover-reactive-4"
                ref="button"
                v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                variant="outline-primary"
                class="transaction-title pointer-name"
                @mouseover="setStatePopup(caseStateData)"
              >
                {{ $t('DEBTIA_TERMINATED') }}
              </h6>
              <div><small>{{ caseStateData.reason }}</small></div>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
      <!-- static actions ends-->
      <hr>
      <!-- current progress starts -->
      <b-row
        v-if="caseProcessesCompleted"
      >
        <b-col sm="12">
          <b-card
            class="processcompletedmessage"
          >
            <b-alert
              variant="primary"
              class="processcompletedmessagealert"
              show
            >
              <div class="alert-body">
                <span>{{ $t('DEBTIA_PROCESS_COMPLETED') }}</span>
              </div>
            </b-alert>
          </b-card>
        </b-col>
      </b-row>
      <b-row
        v-else
      >
        <b-col sm="4">
          <b-list-group>
            <b-list-group-item
              href="#"
              active
            >
              {{ $t('DEBTIA_CURRENT_MODULE') }}
            </b-list-group-item>
            <b-list-group-item
              v-if="!loader"
              href="#"
            >
              {{ caseData.process_data.active_module.module_title ? caseData.process_data.active_module.module_title : 'N/A' }}
            </b-list-group-item>
          </b-list-group>
        </b-col>
        <b-col sm="4">
          <b-list-group>
            <b-list-group-item
              href="#"
              active
            >
              {{ $t('DEBTIA_NEXT_MODULE') }}
            </b-list-group-item>
            <b-list-group-item
              v-if="!loader"
              href="#"
            >
              {{ caseData.process_data.next_module.module_title ? caseData.process_data.next_module.module_title : 'N/A' }}
            </b-list-group-item>
          </b-list-group>
        </b-col>
        <b-col sm="4">
          <b-list-group>
            <b-list-group-item
              href="#"
              active
            >
              {{ $t('DEBTIA_PROCESSES') }}
            </b-list-group-item>
            <div
              v-for="(data,index) in caseData.process_cases"
              :key="index"
            >
              <b-list-group-item :href="`/process/view/${data.process_id}`">
                {{ data.title }}
              </b-list-group-item>
            </div>
          </b-list-group>
        </b-col>
        <b-col
          v-if="caseDetailsData.status && caseDetailsData.status !== 2 && caseData.userActions && caseData.userActions.recipient === 'client'"
          sm="4"
          class="user-action-buttons"
        >
          <b-list-group>
            <b-list-group-item
              href="#"
              active
            >
              User Action Buttons
            </b-list-group-item>
            <b-list-group-item
              v-if="caseData.userActions.await"
            >
              <strong>{{ $t('DEBTIA_AWAIT_DAYS_LEFT').replace('X', caseData.userActions.await_days) }}</strong>
            </b-list-group-item>
            <b-list-group-item>
              <strong>Description: </strong> {{ caseData.userActions.description }}
            </b-list-group-item>
            <b-list-group-item>
              <template v-for="(data, index) in caseData.userActions.buttons">
                <b-button
                  v-if="!data.await"
                  :key="index"
                  :variant="data.button_color.includes('#') ? 'gradient-primary' : `gradient-${data.button_color}`"
                  class="user-action-button"
                  @click="userActionButtonClicked(data.id, caseData.userActions.process_id)"
                >
                  {{ data.button_title }}
                </b-button>
              </template>
              <!-- <b-button
                v-for="(data, index) in caseData.userActions.buttons"
                :key="index"
                :variant="data.button_color.includes('#') ? 'gradient-primary' : `gradient-${data.button_color}`"
                class="user-action-button"
                @click="userActionButtonClicked(data.id, caseData.userActions.process_id)"
              >
                {{ data.button_title }}
              </b-button> -->
            </b-list-group-item>
          </b-list-group>
        </b-col>
      </b-row>
      <!-- current progress ends -->
      <br>
      <hr>
      <b-row>
        <b-col
          sm="12"
          md="7"
          lg="7"
        >
          <b-row>
            <b-col
              sm="12"
              md="12"
              lg="12"
            >
              <b-card
                :id="`debt-statements`"
                :title="$t('DEBTIA_DEBT_STATEMENTS')"
              >
                <!-- <b-table
                :fields="statementsTableFields"
                :items="statementsData"
                striped
                responsive
              >
                <template #cell(category)="row">
                  <b-form-checkbox
                    v-model="row.detailsShowing"
                    plain
                    class="vs-checkbox-con"
                    v-if="row.item.category !== 'SUM'"
                    @change="row.toggleDetails"
                  >
                    {{ row.item.category }}
                  </b-form-checkbox>
                  <div v-else>
                    {{ row.item.category }}
                  </div>
                </template>
                <template #row-details="row">
                  <b-table
                    :fields="statementBaseDocumentsTableFields"
                    :items="row.item.documents"
                    striped
                    responsive
                    thead-class="d-none"
                  >
                    <template #cell(file_link)="data">
                      <b-button
                        v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                        variant="flat-primary"
                        @click="openLink(data.item.file_link)"
                      >
                        {{ data.item.file_link }}
                      </b-button>
                    </template>
                  </b-table> -->

                <b-table
                  :fields="statementsTableFields"
                  :items="statementsData"
                  striped
                  responsive
                  table-class="parent-table"
                >
                  <template #cell(category)="row">
                    <b-link
                      v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                      @click="row.toggleDetails"
                    >
                      {{ ($i18n.locale === 'en') ? row.item.en_name : row.item.da_name }}
                    </b-link>
                  </template>
                  <template #row-details="row">
                    <b-table
                      :fields="statementCostDocumentsTableFields"
                      :items="row.item.costDocuments"
                      striped
                      responsive
                      thead-class="d-none"
                      table-class="child-table"
                    >
                      <template #cell(jobTaskNo)="cost">
                        <b-link
                          v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                          variant="flat-primary"
                          @click="cost.toggleDetails"
                        >
                          {{ ($i18n.locale === 'en') ? cost.item.en_name : cost.item.da_name }}
                        </b-link>
                      </template>
                    </b-table>
                  </template>
                  <template #cell(avatar)="data">
                    <b-avatar :src="data.value" />
                  </template>

                  <template #cell(status)="data">
                    <b-badge :variant="status[1][data.value]">
                      {{ status[0][data.value] }}
                    </b-badge>
                  </template>
                </b-table>
              </b-card>
            </b-col>
          </b-row>
          <b-row>
            <b-col
              sm="12"
              md="12"
              lg="12"
            >
              <b-card
                :title="$t('DEBTIA_DOCUMENTS')"
              >
                <!-- client documents starts -->
                <b-table
                  ref="roles"
                  :fields="tableFields"
                  :items="documentsData"
                  striped
                  responsive
                >
                  <!-- <template #cell(companyname)="data">
                  {{ data.item.get_company.name }}
                </template> -->
                  <template #cell(file_link)="data">
                    <feather-icon
                      icon="ExternalLinkIcon"
                      @click="openLink(data.item.file_link)"
                    />
                  </template>
                  <template #cell(interest_rate_percentage)="data">
                    <div v-if="data.item.category == 'base documents'">
                      {{ (data.item.interest_rate_agreed) ? data.item.interest_rate_percentage + '%' : data.item.default_interest_rate + '% standard process rente' }}
                    </div>
                    <div v-else>
                      -
                    </div>
                  </template>
                <!-- <template #cell(action)="data"> -->
                  <!-- <feather-icon
                    v-b-modal.modal-case-edit
                    icon="ExternalLinkIcon"
                    @click="caseDetails(data.item.id)"
                  /> -->
                  <!-- <b-link
                    :to="{ name: 'case-details', params: { id: data.item.id } }"
                    class="margin-right: 15px; font-weight-bold d-block text-nowrap"
                  >
                    <feather-icon
                      icon="EyeIcon"
                    />
                  </b-link> -->
                  <!-- <feather-icon
                    icon="Trash2Icon"
                    style="color: #ff3737;"
                    @click="confirmDeleteText(data.item.id,data.item.name)"
                  /> -->
                <!-- </template> -->
                </b-table>
              </b-card>
            </b-col>
          </b-row>
          <!-- case documents ends -->
          <!-- case payments starts -->
          <b-row>
            <b-col
              md="12"
              xl="12"
            >
              <b-card
                :title="$t('DEBTIA_DEBT_PAYMENTS')"
              >
                <b-table
                  v-if="paymentsData.length > 0"
                  :fields="paymentsTableFields"
                  :items="paymentsData"
                  striped
                  responsive
                >
                  <template #cell(id)="row">
                    <b-link
                      v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                      @click="row.toggleDetails"
                    >
                      {{ row.item.id }}
                    </b-link>
                  </template>
                  <!-- <template #row-details="row">
                    <b-table
                      :fields="paymentsDataTableFields"
                      :items="row.item.documents"
                      striped
                      responsive
                    >
                      <template #cell(file_link)="data">
                        <b-button
                          v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                          variant="flat-primary"
                          @click="openLink(data.item.file_link)"
                        >
                          {{ data.item.file_link }}
                        </b-button>
                      </template>
                    </b-table>
                  </template> -->
                </b-table>
                <b-alert
                  v-else
                  variant="warning"
                  show
                >
                  <div class="alert-body">
                    {{ $t('DEBTIA_NO_PAYMENTS_MSG') }}
                  </div>
                </b-alert>
              </b-card>
            </b-col>
          </b-row>
          <!-- case payments end -->
          <!-- case paid invoices starts -->
          <b-row>
            <b-col
              md="12"
              xl="12"
            >
              <b-card
                :title="$t('DEBTIA_PAID_INVOICES')"
              >
                <b-table
                  v-if="invoicesData.length > 0"
                  :fields="invoicesTableFields"
                  :items="invoicesData"
                  striped
                  responsive
                >
                  <template #cell(file_link)="data">
                    <feather-icon
                      icon="ExternalLinkIcon"
                      @click="openLink(data.item.file_link)"
                    />
                  </template>
                  <template #cell(sub_total)="data">
                    {{ `${convertToDKK(data.item.sub_total, defaultCurrency)}` }}
                  </template>
                  <template #cell(vat_amount)="data">
                    {{ `${convertToDKK(data.item.vat_amount, defaultCurrency)}` }}
                  </template>
                  <template #cell(total_amount)="data">
                    {{ `${convertToDKK(data.item.total_amount, defaultCurrency)}` }}
                  </template>
                </b-table>
                <b-alert
                  v-else
                  variant="warning"
                  show
                >
                  <div class="alert-body">
                    {{ $t('DEBTIA_NO_INVOICES_MSG') }}
                  </div>
                </b-alert>
              </b-card>
            </b-col>
          </b-row>
        </b-col>
        <b-col
          sm="12"
          md="5"
          lg="5"
        >
          <!-- show debtor, representative and client widget starts -->
          <b-row
            v-if="caseData.length !== 0"
          >
            <!-- solid color -->
            <b-col
              md="12"
              xl="12"
            >
              <b-card
                v-if="caseData.length !== 0"
                class="card-transaction"
                no-body
              >
                <b-card-header>
                  <b-card-title>{{ $t('DEBTIA_DEBTORS') }}</b-card-title>
                </b-card-header>

                <b-card-body
                  class="casedetails-card-body"
                >
                  <div
                    v-for="(data,index) in caseData.debtors"
                    :key="index"
                    class="transaction-item"
                  >
                    <b-media no-body>
                      <b-media-aside v-if="data.isMainDebtor === true">
                        <div
                          class="star-icon-box"
                        >
                          <b-avatar
                            rounded
                            size="42"
                            variant="light-primary"
                          >
                            <div
                              class="star"
                            />
                            <feather-icon
                              size="
                              18"
                              :icon="data.debtor_type === 'person' ? 'UserIcon' : 'HomeIcon'"
                            />
                          </b-avatar>
                        </div>
                      </b-media-aside>
                      <b-media-aside v-else>
                        <b-avatar
                          rounded
                          size="42"
                          variant="light-primary"
                        >
                          <feather-icon
                            size="
                              18"
                            :icon="data.debtor_type === 'person' ? 'UserIcon' : 'HomeIcon'"
                          />
                        </b-avatar>
                      </b-media-aside>
                      <b-media-body>
                        <h6
                          v-if="Boolean(debtorsBelongToCompany)"
                          variant="outline-primary"
                          class="transaction-title"
                        >
                          {{ (data.name) ? data.name : 'debtorName' }}
                        </h6>
                        <h6
                          v-else
                          :id="'popover-reactive-debtor-'+data.id"
                          ref="button"
                          v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                          variant="outline-primary"
                          class="transaction-title pointer-name"
                          @mouseover="setdebtorpopup(data)"
                        >
                          {{ (data.name) ? data.name : 'debtorName' }}
                        </h6>
                        <div><small>{{ data.contact_person }}</small></div>
                        <div><small>{{ data.address.place }}</small></div>
                        <div
                          v-if="data.representative !== null"
                          class="representative-div"
                        >
                          <b-badge variant="primary">
                            {{ $t('DEBTIA_REPRESENTATIVE') }}
                          </b-badge>
                          <h6
                            v-if="Boolean(debtorsBelongToCompany)"
                            variant="outline-primary"
                            class="transaction-title"
                          >
                            {{ (data.representative.name) ? data.representative.name : 'representativeName' }}
                          </h6>
                          <h6
                            v-else
                            :id="'popover-reactive-representative-'+data.id"
                            ref="button"
                            v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                            variant="outline-primary"
                            class="transaction-title pointer-name"
                            @mouseover="setrepresentativepopup(data.representative)"
                          >
                            {{ (data.representative.name) ? data.representative.name : 'representativeName' }}
                          </h6>
                          <div
                            v-if="data.representative !== null"
                          ><small>{{ data.representative.company }}</small></div>
                          <div
                            v-if="data.representative !== null"
                          ><small>{{ data.representative.phone }}</small></div>
                        </div>
                      </b-media-body>
                    </b-media>
                  </div>
                </b-card-body>
              </b-card>

            </b-col>
          </b-row>
          <b-card
            :title="$t('DEBTIA_CASE_LOGS_HISTORY')"
          >
            <!-- search here -->
            <b-form-group>
              <b-input-group>
                <b-form-input
                  id="search"
                  v-model="searchQuery"
                  :placeholder="$t('DEBTIA_SEARCH')"
                  @keyup.enter="getCaseLogsData()"
                />
                <b-input-group-append>
                  <b-button variant="outline-primary">
                    <feather-icon
                      icon="FilterIcon"
                    />
                  </b-button>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
            <div
              v-for="(data,cldindex) in caseLogsData"
              :key="cldindex"
              class="mt-2"
            >
              <div
                v-if="data.type === 'Debt Case Notes'"
              >
                <b-card
                  v-if="canshow(data.content)"
                  class="border mb-0"
                >
                  <b-card-text class="card-text content-heading">
                    <h4>{{ $t('DEBTIA_DEBT_CASE_NOTES') }}</h4>
                  </b-card-text>
                  <div class="border mb-10 padding-content">
                    <div
                      class="business-item"
                    >
                      <div class="d-flex align-items-center justify-content-between">
                        <label
                          class="note-font"
                          v-html="data.note"
                        />
                      </div>
                    </div>
                  </div>
                </b-card>
              </div>
              <div
                v-else-if="['Change Client', 'Change Debtors'].includes(data.type) === false "
              >
                <b-card
                  class="border mb-0"
                >
                  <b-card-text class="card-text content-heading">
                    <h4>{{ data.title }}</h4>
                  </b-card-text>
                  <div
                    id="collapse-1-inner"
                    class="mt-2 content-container"
                  >
                    <div class="border mb-10 padding-content">
                      <div class="note-content-div">
                        {{ data.note }}
                      </div>
                    </div>
                  </div>
                  <app-collapse
                    accordion
                  >
                    <app-collapse-item
                      v-if="data.content.length > 0"
                      :title="$t('DEBTIA_SEE_CONTENT')"
                    >
                      <b-card class="border mb-0">
                        <prism
                          language="javascript"
                          class="rounded"
                        >
                          {{ JSON.stringify(JSON.parse(data.content), null, 2) }}
                        </prism>
                      </b-card>
                    </app-collapse-item>
                  </app-collapse>
                </b-card>
              </div>
            </div>
          </b-card>
          <case-details-modal
            :case-data="showData"
            :selected-state="selectedState"
            :b-title="bTitle"
            :b-varient="bVarient"
            :modal-loads="modalLoader"
            :show="!modalLoader"
            :reload-method="getDetails"
          />
          <b-popover
            v-if="!loader"
            ref="popover"
            target="popover-reactive-1"
            triggers="hover"
            placement="auto"
            container="my-container"
          >
            <template #title>
              <div class="d-flex justify-content-between align-items-center">
                <span>Client Details</span>
              </div>
            </template>
            <b-button
              v-if="$ability.can(constants.action.permissionClientEdit, constants.resource.client)"
              v-ripple.400="'rgba(113, 102, 240, 0.15)'"
              variant="outline-primary"
              :to="{ name: 'client-edit', params: { id: currentHoverClient.id, }, query: { debt_case_id: currentHoverClient.debt_case_id } }"
              target="_blank"
              class="edit-client-btn"
            >
              Edit Client
              <feather-icon
                icon="ExternalLinkIcon"
              />
            </b-button>
            <table
              class="client-details-table"
            >
              <tr
                class="business-item"
              >
                <td class="left-item-padding">
                  {{ $t('DEBTIA_USERNAME') }}</td>
                <td class="right-values item-padding">
                  {{ currentHoverClient.username }}
                </td>
              </tr>
              <tr
                class="business-item"
              >
                <td class="left-item-padding">
                  {{ $t('DEBTIA_NAME') }}</td>
                <td class="right-values item-padding">
                  {{ currentHoverClient.name }}
                </td>
              </tr>
              <tr
                class="business-item"
              >
                <td class="left-item-padding">
                  {{ $t('DEBTIA_EMAIL') }}</td>
                <td class="right-values item-padding">
                  {{ currentHoverClient.email }}
                </td>
              </tr>
              <tr
                class="business-item"
              >
                <td class="left-item-padding">
                  {{ $t('DEBTIA_PHONE') }}</td>
                <td class="right-values item-padding">
                  {{ currentHoverClient.phone }}
                </td>
              </tr>
              <tr
                class="business-item"
              >
                <td class="left-item-padding">
                  {{ $t('DEBTIA_LOGIN') }}</td>
                <td class="right-values item-padding">
                  {{ currentHoverClient.loginStatus === '1' ? 'Allowed' : 'Not Allowed' }}
                </td>
              </tr>
              <tr
                class="business-item"
              >
                <td class="left-item-padding">
                  {{ $t('DEBTIA_BILLING_EMAIL') }}</td>
                <td class="right-values item-padding">
                  {{ currentHoverClient.billing_email ? currentHoverClient.billing_email : 'N/A' }}
                </td>
              </tr>
              <tr
                class="business-item"
              >
                <td class="left-item-padding">
                  {{ $t('DEBTIA_CONTACT_PERSON') }}</td>
                <td class="right-values item-padding">
                  {{ currentHoverClient.contact_person ? currentHoverClient.contact_person : 'N/A' }}
                </td>
              </tr>
              <tr
                class="business-item"
              >
                <td class="left-item-padding">
                  {{ $t('DEBTIA_CLIENT_TYPE') }}</td>
                <td class="right-values item-padding">
                  {{ currentHoverClient.type ? currentHoverClient.type : 'N/A' }}
                </td>
              </tr>
            </table>
            <table
              :class="currentHoverClient.billing_address ? '' : 'table-border'"
              class="client-addressdetails-table"
            >
              <tr
                class="business-item"
              >
                <td class="left-item-padding">
                  <h5>{{ $t('DEBTIA_ADDRESS') }}</h5></td>
              </tr>
              <tr
                class="business-item"
              >
                <td class="left-item-padding">
                  {{ $t('DEBTIA_HOUSE_NUMBER') }}</td>
                <td class="right-values item-padding">
                  {{ currentHoverClient.address.house_number ? currentHoverClient.address.house_number : 'N/A' }}
                </td>
              </tr>
              <tr
                class="business-item"
              >
                <td class="left-item-padding">
                  {{ $t('DEBTIA_ROAD_NAME') }}</td>
                <td class="right-values item-padding">
                  {{ currentHoverClient.address.road_name ? currentHoverClient.address.road_name : 'N/A' }}
                </td>
              </tr>
              <tr
                class="business-item"
              >
                <td class="left-item-padding">
                  {{ $t('DEBTIA_PLACE_NAME') }}</td>
                <td class="right-values item-padding">
                  {{ currentHoverClient.address.place ? currentHoverClient.address.place : 'N/A' }}
                </td>
              </tr>
              <tr
                class="business-item"
              >
                <td class="left-item-padding">
                  {{ $t('DEBTIA_ZIP_CODE') }}</td>
                <td class="right-values item-padding">
                  {{ currentHoverClient.address.zip_code ? currentHoverClient.address.zip_code : 'N/A' }}
                </td>
              </tr>
              <tr
                class="business-item"
              >
                <td class="left-item-padding">
                  {{ $t('DEBTIA_CITY') }}</td>
                <td class="right-values item-padding">
                  {{ currentHoverClient.address.city ? currentHoverClient.address.city : 'N/A' }}
                </td>
              </tr>
              <tr
                class="business-item"
              >
                <td class="left-item-padding">
                  {{ $t('DEBTIA_COUNTRY') }}</td>
                <td class="right-values item-padding">
                  {{ currentHoverClient.address.country ? currentHoverClient.address.country : 'N/A' }}
                </td>
              </tr>
            </table>
            <table
              v-if="currentHoverClient.billing_address"
              class="client-addressdetails-table table-border"
            >
              <tr
                class="business-item"
              >
                <td class="left-item-padding">
                  <h5>{{ $t('DEBTIA_BILLING_ADDRESS') }}</h5></td>
              </tr>
              <tr
                class="business-item"
              >
                <td class="left-item-padding">
                  {{ $t('DEBTIA_HOUSE_NUMBER') }}</td>
                <td class="right-values item-padding">
                  {{ currentHoverClient.billing_address ? currentHoverClient.billing_address.house_number : 'N/A' }}
                </td>
              </tr>
              <tr
                class="business-item"
              >
                <td class="left-item-padding">
                  {{ $t('DEBTIA_ROAD_NAME') }}</td>
                <td class="right-values item-padding">
                  {{ currentHoverClient.billing_address.road_name ? currentHoverClient.billing_address.road_name : 'N/A' }}
                </td>
              </tr>
              <tr
                class="business-item"
              >
                <td class="left-item-padding">
                  {{ $t('DEBTIA_PLACE_NAME') }}</td>
                <td class="right-values item-padding">
                  {{ currentHoverClient.billing_address.place ? currentHoverClient.billing_address.place : 'N/A' }}
                </td>
              </tr>
              <tr
                class="business-item"
              >
                <td class="left-item-padding">
                  {{ $t('DEBTIA_ZIP_CODE') }}</td>
                <td class="right-values item-padding">
                  {{ currentHoverClient.billing_address.zip_code ? currentHoverClient.billing_address.zip_code : 'N/A' }}
                </td>
              </tr>
              <tr
                class="business-item"
              >
                <td class="left-item-padding">
                  {{ $t('DEBTIA_CITY') }}</td>
                <td class="right-values item-padding">
                  {{ currentHoverClient.billing_address.city ? currentHoverClient.billing_address.city : 'N/A' }}
                </td>
              </tr>
              <tr
                class="business-item"
              >
                <td class="left-item-padding">
                  {{ $t('DEBTIA_COUNTRY') }}</td>
                <td class="right-values item-padding">
                  {{ currentHoverClient.billing_address.country ? currentHoverClient.billing_address.country : 'N/A' }}
                </td>
              </tr>
            </table>
          </b-popover>
          <b-popover
            v-for="(data,index) in caseData.debtors"
            :key="index"
            ref="popover"
            :target="'popover-reactive-debtor-'+data.id"
            triggers="hover"
            placement="auto"
            container="my-container"
          >
            <template #title>
              <div class="d-flex justify-content-between align-items-center">
                <span>Debtor Details</span>
              </div>
            </template>
            <b-button
              v-if="$ability.can(constants.action.permissionDebtorEdit, constants.resource.debtor)"
              v-ripple.400="'rgba(113, 102, 240, 0.15)'"
              variant="outline-primary"
              :to="{ name: 'debtor-edit', params: { id: currentHoverDebtor.id } }"
              target="_blank"
              class="edit-client-btn"
            >
              Edit Debtor
              <feather-icon
                icon="ExternalLinkIcon"
              />
            </b-button>
            <table
              class="client-details-table"
            >
              <tr
                class="business-item"
              >
                <td class="left-item-padding">
                  {{ $t('DEBTIA_USERNAME') }}</td>
                <td class="right-values item-padding">
                  {{ currentHoverDebtor.username }}
                </td>
              </tr>
              <tr
                class="business-item"
              >
                <td class="left-item-padding">
                  {{ $t('DEBTIA_NAME') }}</td>
                <td class="right-values item-padding">
                  {{ currentHoverDebtor.name }}
                </td>
              </tr>
              <tr
                class="business-item"
              >
                <td class="left-item-padding">
                  {{ $t('DEBTIA_EMAIL') }}</td>
                <td class="right-values item-padding">
                  {{ currentHoverDebtor.email }}
                </td>
              </tr>
              <tr
                class="business-item"
              >
                <td class="left-item-padding">
                  {{ $t('DEBTIA_PHONE') }}</td>
                <td class="right-values item-padding">
                  {{ currentHoverDebtor.phone ? currentHoverDebtor.phone : 'N/A' }}
                </td>
              </tr>
              <tr
                class="business-item"
              >
                <td class="left-item-padding">
                  {{ $t('DEBTIA_LOGIN') }}</td>
                <td class="right-values item-padding">
                  {{ currentHoverDebtor.loginStatus === '1' ? 'Allowed' : 'Not Allowed' }}
                </td>
              </tr>
              <tr
                class="business-item"
              >
                <td class="left-item-padding">
                  {{ $t('DEBTIA_SELECT_CLIENT') }}</td>
                <td class="right-values item-padding">
                  {{ currentHoverDebtor.client_id ? currentHoverDebtor.client_id : 'N/A' }}
                </td>
              </tr>
              <tr
                class="business-item"
              >
                <td class="left-item-padding">
                  {{ $t('DEBTIA_CONTACT_PERSON') }}</td>
                <td class="right-values item-padding">
                  {{ currentHoverDebtor.contact_person ? currentHoverDebtor.contact_person : 'N/A' }}
                </td>
              </tr>
              <tr
                class="business-item"
              >
                <td class="left-item-padding">
                  {{ $t('DEBTIA_DEBTOR_TYPE') }}</td>
                <td class="right-values item-padding">
                  {{ currentHoverDebtor.debtor_type ? currentHoverDebtor.debtor_type : 'N/A' }}
                </td>
              </tr>
              <tr
                v-if="currentHoverDebtor.debtor_type !== 'person'"
                class="business-item"
              >
                <td class="left-item-padding">
                  {{ $t('DEBTIA_CVRCPR') }}</td>
                <td class="right-values item-padding">
                  {{ currentHoverDebtor.cvr_number ? currentHoverDebtor.cvr_number : 'N/A' }}
                </td>
              </tr>
              <tr
                v-if="currentHoverDebtor.debtor_type === 'person'"
                class="business-item"
              >
                <td class="left-item-padding">
                  {{ $t('DEBTIA_BIRTHDATE') }}</td>
                <td class="right-values item-padding">
                  {{ currentHoverDebtor.birthdate ? currentHoverDebtor.birthdate : 'N/A' }}
                </td>
              </tr>
            </table>
            <table
              v-if="currentHoverDebtor.address"
              class="client-addressdetails-table table-border"
            >
              <tr
                class="business-item"
              >
                <td class="left-item-padding">
                  <h5>{{ $t('DEBTIA_ADDRESS') }}</h5></td>
              </tr>
              <tr
                class="business-item"
              >
                <td class="left-item-padding">
                  {{ $t('DEBTIA_HOUSE_NUMBER') }}</td>
                <td class="right-values item-padding">
                  {{ currentHoverDebtor.address.house_number ? currentHoverDebtor.address.house_number : 'N/A' }}
                </td>
              </tr>
              <tr
                class="business-item"
              >
                <td class="left-item-padding">
                  {{ $t('DEBTIA_ROAD_NAME') }}</td>
                <td class="right-values item-padding">
                  {{ currentHoverDebtor.address.road_name ? currentHoverDebtor.address.road_name : 'N/A' }}
                </td>
              </tr>
              <tr
                class="business-item"
              >
                <td class="left-item-padding">
                  {{ $t('DEBTIA_PLACE_NAME') }}</td>
                <td class="right-values item-padding">
                  {{ currentHoverDebtor.address.place ? currentHoverDebtor.address.place : 'N/A' }}
                </td>
              </tr>
              <tr
                class="business-item"
              >
                <td class="left-item-padding">
                  {{ $t('DEBTIA_ZIP_CODE') }}</td>
                <td class="right-values item-padding">
                  {{ currentHoverDebtor.address.zip_code ? currentHoverDebtor.address.zip_code : 'N/A' }}
                </td>
              </tr>
              <tr
                class="business-item"
              >
                <td class="left-item-padding">
                  {{ $t('DEBTIA_CITY') }}</td>
                <td class="right-values item-padding">
                  {{ currentHoverDebtor.address.city ? currentHoverDebtor.address.city : 'N/A' }}
                </td>
              </tr>
              <tr
                class="business-item"
              >
                <td class="left-item-padding">
                  {{ $t('DEBTIA_COUNTRY') }}</td>
                <td class="right-values item-padding">
                  {{ currentHoverDebtor.address.country ? currentHoverDebtor.address.country : 'N/A' }}
                </td>
              </tr>
            </table>
          </b-popover>
          <b-popover
            v-for="(data,index) in caseData.debtors"
            :key="index"
            ref="popover"
            :target="'popover-reactive-representative-'+data.id"
            triggers="hover"
            placement="auto"
            container="my-container"
          >
            <template #title>
              <div class="d-flex justify-content-between align-items-center">
                <span>Representative Details</span>
              </div>
            </template>
            <table
              class="client-details-table"
            >
              <tr
                class="business-item"
              >
                <td class="left-item-padding">
                  {{ $t('DEBTIA_NAME') }}</td>
                <td class="right-values item-padding">
                  {{ currentHoverRepresentative.name }}
                </td>
              </tr>
              <tr
                class="business-item"
              >
                <td class="left-item-padding">
                  {{ $t('DEBTIA_EMAIL') }}</td>
                <td class="right-values item-padding">
                  {{ currentHoverRepresentative.email }}
                </td>
              </tr>
              <tr
                class="business-item"
              >
                <td class="left-item-padding">
                  {{ $t('DEBTIA_PHONE') }}</td>
                <td class="right-values item-padding">
                  {{ currentHoverRepresentative.phone ? currentHoverRepresentative.phone : 'N/A' }}
                </td>
              </tr>
              <tr
                class="business-item"
              >
                <td class="left-item-padding">
                  {{ $t('DEBTIA_CONTACT_PERSON') }}</td>
                <td class="right-values item-padding">
                  {{ currentHoverRepresentative.company ? currentHoverRepresentative.company : 'N/A' }}
                </td>
              </tr>
            </table>
            <table
              v-if="currentHoverRepresentative.representative_address"
              class="client-addressdetails-table table-border"
            >
              <tr
                class="business-item"
              >
                <td class="left-item-padding">
                  <h5>{{ $t('DEBTIA_ADDRESS') }}</h5></td>
              </tr>
              <tr
                class="business-item"
              >
                <td class="left-item-padding">
                  {{ $t('DEBTIA_HOUSE_NUMBER') }}</td>
                <td class="right-values item-padding">
                  {{ currentHoverRepresentative.representative_address.house_number ? currentHoverRepresentative.representative_address.house_number : 'N/A' }}
                </td>
              </tr>
              <tr
                class="business-item"
              >
                <td class="left-item-padding">
                  {{ $t('DEBTIA_ROAD_NAME') }}</td>
                <td class="right-values item-padding">
                  {{ currentHoverRepresentative.representative_address.road_name ? currentHoverRepresentative.representative_address.road_name : 'N/A' }}
                </td>
              </tr>
              <tr
                class="business-item"
              >
                <td class="left-item-padding">
                  {{ $t('DEBTIA_PLACE_NAME') }}</td>
                <td class="right-values item-padding">
                  {{ currentHoverRepresentative.representative_address.place ? currentHoverRepresentative.representative_address.place : 'N/A' }}
                </td>
              </tr>
              <tr
                class="business-item"
              >
                <td class="left-item-padding">
                  {{ $t('DEBTIA_ZIP_CODE') }}</td>
                <td class="right-values item-padding">
                  {{ currentHoverRepresentative.representative_address.zip_code ? currentHoverRepresentative.representative_address.zip_code : 'N/A' }}
                </td>
              </tr>
              <tr
                class="business-item"
              >
                <td class="left-item-padding">
                  {{ $t('DEBTIA_CITY') }}</td>
                <td class="right-values item-padding">
                  {{ currentHoverRepresentative.representative_address.city ? currentHoverRepresentative.representative_address.city : 'N/A' }}
                </td>
              </tr>
              <tr
                class="business-item"
              >
                <td class="left-item-padding">
                  {{ $t('DEBTIA_COUNTRY') }}</td>
                <td class="right-values item-padding">
                  {{ currentHoverRepresentative.representative_address.country ? currentHoverRepresentative.representative_address.country : 'N/A' }}
                </td>
              </tr>
            </table>
          </b-popover>
          <b-popover
            v-if="!loader"
            ref="popover"
            target="popover-reactive-3"
            triggers="hover"
            placement="auto"
            container="my-container"
          >
            <template #title>
              <div class="d-flex justify-content-between align-items-center">
                <span>Representative Details</span>
              </div>
            </template>
            <table
              class="client-details-table table-border"
            >
              <tr
                class="business-item"
              >
                <td class="left-item-padding">
                  {{ $t('DEBTIA_USERNAME') }}</td>
                <td class="right-values item-padding">
                  {{ currentHoverEmployee.username }}
                </td>
              </tr>
              <tr
                class="business-item"
              >
                <td class="left-item-padding">
                  {{ $t('DEBTIA_NAME') }}</td>
                <td class="right-values item-padding">
                  {{ currentHoverEmployee.name }}
                </td>
              </tr>
              <tr
                class="business-item"
              >
                <td class="left-item-padding">
                  {{ $t('DEBTIA_EMAIL') }}</td>
                <td class="right-values item-padding">
                  {{ currentHoverEmployee.email }}
                </td>
              </tr>
              <tr
                class="business-item"
              >
                <td class="left-item-padding">
                  {{ $t('DEBTIA_PHONE') }}</td>
                <td class="right-values item-padding">
                  {{ currentHoverEmployee.phone }}
                </td>
              </tr>
              <tr
                class="business-item"
              >
                <td class="left-item-padding">
                  {{ $t('DEBTIA_ADDRESS') }}</td>
                <td class="right-values item-padding">
                  {{ currentHoverEmployee.address ? currentHoverEmployee.address : 'N/A' }}
                </td>
              </tr>
              <tr
                class="business-item"
              >
                <td class="left-item-padding">
                  {{ $t('DEBTIA_LOGIN') }}</td>
                <td class="right-values item-padding">
                  {{ currentHoverEmployee.loginStatus === '1' ? 'Allowed' : 'Not Allowed' }}
                </td>
              </tr>
            </table>
          </b-popover>
          <b-popover
            v-if="!loader"
            ref="popover"
            target="popover-reactive-4"
            triggers="hover"
            placement="auto"
            container="my-container"
            variant="danger"
          >
            <template #title>
              <div class="d-flex justify-content-between align-items-centers">
                <span v-if="caseDetailsData.status === 2">{{ $t('DEBTIA_CASE_DECLINED_BECAUSE') }}</span>
                <span v-if="caseDetailsData.status === 3">{{ $t('DEBTIA_CASE_TERMINATED_BECAUSE') }}</span>
              </div>
            </template>
            <table
              class="client-details-table table-border"
            >
              <tr
                class="business-item"
              >
                <td class="left-item-padding">
                  {{ $t('DEBTIA_REASON') }}</td>
                <td class="right-values item-padding">
                  {{ currentHoverStateData.reason }}
                </td>
              </tr>
              <tr
                class="business-item"
              >
                <td class="left-item-padding">
                  {{ $t('DEBTIA_DESCRIPTION') }}</td>
                <td class="right-values item-padding">
                  {{ currentHoverStateData.description }}
                </td>
              </tr>
            </table>
          </b-popover>
        </b-col>
      </b-row>
      <terminate-data-modal
        ref="terminateModal"
        :case-data="showData"
        :case-state-title="caseStateTitle"
        :modal-loads="loader"
        :show="!loader"
        :reload-method="getDetails"
      />
    </b-overlay>
  </section>
</template>

<script>
import {
  BRow,
  BCol,
  BCard,
  BButton,
  BTable,
  BOverlay,
  BCardTitle,
  VBToggle,
  BCardText,
  BFormGroup,
  BFormInput,
  BInputGroup,
  BInputGroupAppend,
  BListGroup,
  BListGroupItem,
  BBadge,
  BAvatar,
  BLink,
  VBPopover,
  BCardHeader,
  BMediaBody,
  BMedia,
  BMediaAside,
  BCardBody,
  BPopover,
  BBreadcrumb,
  BBreadcrumbItem,
  BAlert,
} from 'bootstrap-vue'
// slint-disable-next-line vue/no-unused-components
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import Ripple from 'vue-ripple-directive'
import { required } from '@validations'
import router from '@/router'
import axios from '@axios'
import i18n from '@/libs/i18n'
import constants from '@/app-configs/constants'
import AppCollapse from '@core/components/app-collapse/AppCollapse.vue'
import AppCollapseItem from '@core/components/app-collapse/AppCollapseItem.vue'
import Prism from 'vue-prism-component'
import 'prismjs'
import 'prismjs/themes/prism-tomorrow.css'
import CaseDetailsModal from './CaseDetailsModal.vue'
import TerminateDataModal from './TerminateDataModal.vue'
// import CaseCustomVariables from './CaseCustomVariables.vue'
// import EditClientModal from './EditClientModal.vue'
// import EditDebtorModal from './EditDebtorModal.vue'
// import EditRepresentativeModal from './EditRepresentativeModal.vue'

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BButton,
    CaseDetailsModal,
    // CaseCustomVariables,
    TerminateDataModal,
    BTable,
    BOverlay,
    BCardTitle,
    // EditClientModal,
    // EditDebtorModal,
    // EditRepresentativeModal,
    BCardText,
    BFormGroup,
    BFormInput,
    BInputGroup,
    BInputGroupAppend,
    BListGroup,
    BListGroupItem,
    AppCollapse,
    AppCollapseItem,
    Prism,
    BBadge,
    BAvatar,
    BLink,
    BCardHeader,
    BMediaBody,
    BMedia,
    BMediaAside,
    BCardBody,
    BPopover,
    BBreadcrumb,
    BBreadcrumbItem,
    // eslint-disable-next-line vue/no-unused-components
    ToastificationContent,
    BAlert,
  },
  directives: {
    'b-toggle': VBToggle,
    'b-popover': VBPopover,
    Ripple,
  },
  data() {
    return {
      caseData: {},
      caseDetailsData: {},
      caseTaskActionData: {},
      documentsData: [],
      caseStateData: [],
      statementsData: [],
      costStatementsData: [],
      collectionFeesData: [],
      compansationFeesData: [],
      statementsAmount: [],
      reminderDocumentsData: [],
      collectionCostsData: [],
      paymentsData: [],
      clients: [],
      id: 0,
      snowOption: {
        theme: 'snow',
      },
      required,
      details: {},
      user_type: JSON.parse(localStorage.getItem('userData')).data.user_type,
      user_role: JSON.parse(localStorage.getItem('userData')).role[0],
      apiBody: '',
      pdfLink: '',
      name: '',
      reason: '',
      state: '',
      description: '',
      companyname: '',
      busy: false,
      showData: {},
      selectedState: '',
      caseStateTitle: '',
      bTitle: '',
      bVarient: '',
      modalLoader: true,
      loader: true,
      generalLoader: false,
      upHere: false,
      clientsObj: [],
      isHovered: false,
      caseId: 0,
      value: 'Some value',
      caseLogsData: [],
      caseCustomVariables: [],
      caseStatements: [],
      noteRoles: [],
      perPage: 1000000,
      perPageOptions: [10, 25, 50, 100],
      searchQuery: '',
      totalPages: 0,
      from: 0,
      to: 0,
      currentPage: 1,
      isBlur: false,
      activeClass: 'active',
      errorClass: '',
      currentHoverClient: {
        address: {},
        billing_address: {},
      },
      currentHoverDebtor: {
        address: {},
      },
      currentHoverRepresentative: {
        address: {},
      },
      currentHoverEmployee: {},
      currentHoverStateData: {},
      constants,
      invoicesData: [],
      caseProcessesCompleted: null,
      defaultCurrency: '',
      debt_case_state: null,
      debtorsBelongToCompany: localStorage.getItem('debtorsBelongTo') === 'company',
    }
  },
  setup() {
    const reasonOptions = []
    const reasonOptionsArgs = []
    const requestArgs = [
      { request: '/get-reason-options', param: 'reasonOptions' },
    ]
    return {
      reasonOptions,
      reasonOptionsArgs,
      requestArgs,
    }
  },
  computed: {
    classObject() {
      return {
        active: this.isBlur,
        style: 'filter: blur(1px); pointer-events: none;',
      }
    },
    tableFields() {
      return [
        {
          key: 'category', sortable: true, label: i18n.t('DEBTIA_CATEGORY'), tdClass: 'text-capitalize',
        },
        { key: 'title', sortable: true, label: i18n.t('DEBTIA_TITLE') },
        { key: 'file_link', sortable: true, label: i18n.t('DEBTIA_FILE_LINK') },
        { key: 'payment_amount', sortable: true, label: i18n.t('DEBTIA_PAYMENT_AMOUNT') },
        { key: 'vat_amount', sortable: true, label: i18n.t('DEBTIA_VAT_AMOUNT') },
        { key: 'paid_amount', sortable: true, label: i18n.t('DEBTIA_PAID_AMOUNT') },
        { key: 'interest_rate_percentage', sortable: true, label: i18n.t('DEBTIA_INTEREST_RATE') },
        { key: 'document_due_date', sortable: true, label: i18n.t('DEBTIA_DOCUMENT_DUE_DATE') },
        { key: 'document_send_date', sortable: true, label: i18n.t('DEBTIA_DOCUMENT_SENT_DATE') },
      ]
    },
    statementsTableFields() {
      return [
        { key: 'category', label: '', tdClass: 'text-left' },
        { key: 'total_amount', label: i18n.t('DEBTIA_TOTAL_AMOUNT'), tdClass: 'text-right' },
        { key: 'paid_amount', label: i18n.t('DEBTIA_PAID_AMOUNT'), tdClass: 'text-right' },
        { key: 'rest_amount', label: i18n.t('DEBTIA_REST_AMOUNT'), tdClass: 'text-right' },
      ]
    },
    statementBaseDocumentsTableFields() {
      return [
        { key: 'file_link', label: '-', tdClass: 'text-left' },
        { key: 'total_amount', label: '-', tdClass: 'text-right' },
        { key: 'paid_amount', label: '-', tdClass: 'text-right' },
        { key: 'rest_amount', label: '-', tdClass: 'text-right' },
      ]
    },
    statementCostDocumentsTableFields() {
      return [
        { key: 'category', label: '-', tdClass: 'text-left' },
        { key: 'total_amount', label: '-', tdClass: 'text-right' },
        { key: 'paid_amount', label: '-', tdClass: 'text-right' },
        { key: 'rest_amount', label: '-', tdClass: 'text-right' },
      ]
    },
    paymentsTableFields() {
      return [
        { key: 'id', label: '' },
        { key: 'payment_date', label: i18n.t('DEBTIA_PAYMENT_DATE') },
        { key: 'amount', label: i18n.t('DEBTIA_AMOUNT') },
        { key: 'remaining_amount', label: i18n.t('DEBTIA_REMAINING_AMOUNT') },
      ]
    },
    paymentsDataTableFields() {
      return [
        { key: 'category', label: '-' },
        { key: 'payment_date', label: '-' },
        { key: 'total_amount', label: '-' },
      ]
    },
    invoicesTableFields() {
      return [
        { key: 'file_link', sortable: true, label: i18n.t('DEBTIA_FILE_LINK') },
        { key: 'payment_id', label: i18n.t('DEBTIA_PAYMENT_ID'), tdClass: 'text-right' },
        { key: 'sub_total', label: i18n.t('DEBTIA_SUB_TOTAL'), tdClass: 'text-right' },
        { key: 'vat_amount', sortable: true, label: i18n.t('DEBTIA_VAT_AMOUNT') },
        { key: 'total_amount', label: i18n.t('DEBTIA_TOTAL_AMOUNT'), tdClass: 'text-right' },
      ]
    },
  },
  watch: {
    searchQuery: {
      handler() {
        if (this.searchQuery.length === 0 && this.searchRun) {
          this.searchRun = false
          this.currentPage = 1
          this.getCaseLogsData()
        }
      },
    },
    currentPage: {
      handler() {
        this.getCaseLogsData()
      },
    },
    perPage: {
      handler() {
        this.currentPage = 1
        this.getCaseLogsData()
      },
    },
  },
  created() {
    this.getReasons()
    this.getDetails()
    // this.getClients()
  },
  methods: {
    canshow(contents) {
      let exists = false
      if (contents) {
        const arr = JSON.parse(contents)
        arr.forEach(element => {
          if (element === this.user_role) {
            exists = true
          }
        })
      }
      return exists
    },
    userActionButtonClicked(buttonId, processId) {
      this.generalLoader = true
      const caseId = this.$route.params.id
      const form = new FormData()
      form.append('process_id', processId)
      form.append('button_id', buttonId)
      form.append('case_id', caseId)
      const url = '/run-button-module'
      axios.post(url, form).then(response => {
        if (response.status === 200) {
          this.$toast({
            component: ToastificationContent,
            position: 'top-right',
            props: {
              title: 'Success',
              icon: 'CoffeeIcon',
              variant: 'success',
              text: 'Action performed on button.',
            },
          })
          this.getDetails()
        }
      })
    },
    copyCode(id) {
      let codeToCopy = ''
      if (id === 'copy-bc-case-id') {
        codeToCopy = document.querySelector(`#${id}`)
      }
      if (id === 'copy-case-id') {
        codeToCopy = document.querySelector(`#${id}`)
      }
      codeToCopy.setAttribute('type', 'text')
      codeToCopy.select()
      try {
        document.execCommand('copy')
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Text copied',
            icon: 'BellIcon',
          },
        })
      } catch (err) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Failed to copy texts!',
            icon: 'BellIcon',
          },
        })
      }
      /* unselect the range */
      codeToCopy.setAttribute('type', 'hidden')
      window.getSelection().removeAllRanges()
    },
    addRows() {
    },
    setrepresentativepopup(representative) {
      this.currentHoverRepresentative = representative
    },
    setdebtorpopup(debtor) {
      this.currentHoverDebtor = debtor
    },
    setpopup(client) {
      this.currentHoverClient = client
    },
    setStatePopup(data) {
      this.currentHoverStateData = data
    },
    async getReasons() {
      try {
        await Promise.all(
          this.requestArgs
            .map(REQUEST => axios
              .get(REQUEST.request)
              .then(res => {
                if (REQUEST.param === 'reasonOptions') {
                  this.reasonOptions = [...res.data.data]
                }
              })),
        )
          .then(() => {
            this.loading = false
          })
      } catch (error) {
        console.log('options error', error)
      }
    },
    // async getClients() {
    //   this.loader = true
    //   await axios.get('clients/dropdown')
    //     .then(response => {
    //       this.loader = false
    //       this.clientsObj.push(...response.data.data)
    //     }).catch(error => {
    //       console.log(error)
    //     })
    // },
    async openLink(href) {
      window.open(href, '_blank')
    },
    convertToDKK(amount, defaultCurrency) {
      return new Intl.NumberFormat('da-DK', { style: 'currency', currency: defaultCurrency }).format(parseFloat(amount).toFixed(2))
    },
    async getDetails() {
      this.caseId = router.currentRoute.params.id
      const caseDetails = await axios.get(`${constants.baseUrl}/get-debt-case/${this.caseId}`).catch(error => {
        if (error.response.status === 404) {
          this.$router.push('/cases')
        }
      })
      if (caseDetails.status) {
        // this.caseProcessesCompleted = 88
        const processCase = caseDetails.data.data.process_cases
        // debugger
        this.caseProcessesCompleted = processCase.length > 0 ? caseDetails.data.data.process_cases[0].completed : 0
        if (caseDetails.data.data.debt_case_state !== null && typeof caseDetails.data.data.debt_case_state !== 'undefined') {
          this.caseStateData = caseDetails.data.data.debt_case_state
          this.state = caseDetails.data.data.debt_case_state.state
          // if (this.state === 'terminate') {
          //   this.isBlur = true
          //   this.getTerminateData(this.caseStateData, 'terminate')
          // }
        } else {
          this.caseStateData.debt_case_id = this.caseId
        }
        if (caseDetails.data.data !== null) {
          this.debt_case_state = caseDetails.data.data.debt_case_state
          this.caseData = { ...caseDetails.data.data }
          this.caseCustomVariables = this.caseData.custom_vars
          this.caseDetailsData = this.caseData.debt_case
          if (this.caseDetailsData.status === 2) {
            this.isBlur = true
            this.getTerminateData(this.caseStateData, 'decline')
          }
          if (this.caseDetailsData.status === 3) {
            this.isBlur = true
            this.getTerminateData(this.caseStateData, 'terminate')
          }
          this.caseTaskActionData = this.caseData.task_action
          this.caseStateData.creditor_id = (caseDetails.data.data.client) ? caseDetails.data.data.client.id : 0
          this.caseStateData.remaining_debt_amount = (caseDetails.data.data.remainingDebtAmount) ? caseDetails.data.data.remainingDebtAmount : 0
          this.caseLogsData = caseDetails.data.data.get_logs
          this.caseStatements = caseDetails.data.data.statements
          this.invoicesData = caseDetails.data.data.invoices
          const headingData = Object.keys(caseDetails.data.data)
          this.headingArray = headingData
          let newObj = null
          let statementGroups = null
          const baseDocumentsData = []
          const paymentDocumentsData = []
          // let baseDocTotal = 0
          this.statementsData = []
          this.documentsData = []
          this.costStatementsData = []
          this.costStatementsData1 = []
          this.statementsAmount = []
          let baseDocPaid = 0
          let principalPaid = caseDetails.data.data.statements[1].paidAmount
          const defaultCurrency = typeof caseDetails.data.data.debt_case.default_currency !== 'undefined' ? caseDetails.data.data.debt_case.default_currency : 'DKK'
          this.defaultCurrency = defaultCurrency
          headingData.forEach(element => {
            if (element === 'base_documents' || element === 'credit_notes' || element === 'debt_reminders' || element === 'other_files') {
              newObj = caseDetails.data.data[element]
              newObj.forEach(key => {
                if (typeof key.file_link !== 'undefined') {
                  const objArr = []
                  objArr.id = key.id
                  objArr.category = (key.category === '' || typeof key.category === 'undefined') ? element.replace('_', ' ') : key.category
                  objArr.file_link = key.file_link
                  objArr.title = (key.title) ? key.title : '-'
                  objArr.payment_amount = (key.payment_amount) ? new Intl.NumberFormat('da-DK', { style: 'currency', currency: defaultCurrency }).format(parseFloat(key.payment_amount).toFixed(2)) : '-'
                  objArr.vat_amount = (key.vat_amount) ? new Intl.NumberFormat('da-DK', { style: 'currency', currency: defaultCurrency }).format(parseFloat(key.vat_amount).toFixed(2)) : '-'
                  objArr.paid_amount = (key.paid_amount) ? new Intl.NumberFormat('da-DK', { style: 'currency', currency: defaultCurrency }).format(parseFloat(key.paid_amount).toFixed(2)) : '-'
                  objArr.interest_rate_percentage = key.interest_rate_percentage
                  objArr.interest_rate_agreed = key.interest_rate_agreed
                  objArr.default_interest_rate = (key.interest_rate_agreed) ? key.interest_rate_percentage : key.interest_rate_percentage
                  objArr.document_due_date = (key.document_due_date) ? key.document_due_date : '-'
                  objArr.document_send_date = (key.document_send_date) ? key.document_send_date : '-'
                  if (element === 'credit_notes') {
                    objArr.payment_amount = new Intl.NumberFormat('da-DK', { style: 'currency', currency: defaultCurrency }).format(parseFloat(key.credit_note_amount).toFixed(2))
                  }
                  if (element === 'debt_reminders') {
                    objArr.payment_amount = new Intl.NumberFormat('da-DK', { style: 'currency', currency: defaultCurrency }).format((parseFloat(key.compensation_fee) + parseFloat(key.reminder_fee)).toFixed(2))
                  }
                  this.documentsData.push(objArr)
                  if (element === 'base_documents') {
                    objArr.id = key.id
                    objArr.file_link = key.file_link
                    objArr.total_amount = key.payment_amount + key.vat_amount
                    objArr.rest_amount = key.payment_amount + key.vat_amount - key.paid_amount
                    // add paid principal to base doc paid amount
                    let docPaidAmount = parseFloat(key.paid_amount)
                    let docRestAmount = parseFloat(objArr.rest_amount)
                    if (principalPaid > parseFloat(objArr.rest_amount)) {
                      docPaidAmount += parseFloat(objArr.rest_amount)
                      principalPaid -= parseFloat(objArr.rest_amount)
                    } else {
                      docPaidAmount += parseFloat(principalPaid)
                      principalPaid = 0
                    }
                    docRestAmount = key.payment_amount + key.vat_amount - parseFloat(docPaidAmount)
                    objArr.total_amount = new Intl.NumberFormat('da-DK', { style: 'currency', currency: defaultCurrency }).format(parseFloat(objArr.total_amount).toFixed(2))
                    objArr.paid_amount = new Intl.NumberFormat('da-DK', { style: 'currency', currency: defaultCurrency }).format(parseFloat(docPaidAmount).toFixed(2))
                    objArr.rest_amount = new Intl.NumberFormat('da-DK', { style: 'currency', currency: defaultCurrency }).format(parseFloat(docRestAmount).toFixed(2))
                    baseDocumentsData.push(objArr)

                    // baseDocTotal += parseFloat(key.payment_amount) + parseFloat(key.vat_amount)
                    baseDocPaid = parseFloat(baseDocPaid) + parseFloat(key.paid_amount)
                  }
                  if (element === 'credit_notes') {
                    objArr.id = key.id
                    objArr.file_link = key.file_link
                    objArr.total_amount = 0
                    objArr.total_amount = new Intl.NumberFormat('da-DK', { style: 'currency', currency: defaultCurrency }).format(parseFloat(objArr.total_amount).toFixed(2))
                    objArr.paid_amount = new Intl.NumberFormat('da-DK', { style: 'currency', currency: defaultCurrency }).format(parseFloat(key.credit_note_amount).toFixed(2))
                    objArr.rest_amount = 0 - key.credit_note_amount
                    objArr.rest_amount = new Intl.NumberFormat('da-DK', { style: 'currency', currency: defaultCurrency }).format(parseFloat(objArr.rest_amount).toFixed(2))
                    baseDocumentsData.push(objArr)

                    baseDocPaid += parseFloat(key.credit_note_amount)
                  }
                }
              })
            }
            if (element === 'statements') {
              const statementsKeysRow = []
              statementGroups = caseDetails.data.data[element]
              statementGroups.forEach(statementGroupValue => {
                const newGroup = {}
                newGroup.en_name = statementGroupValue.en_name
                newGroup.da_name = statementGroupValue.da_name
                newGroup.category = (i18n.locale === 'en') ? statementGroupValue.en_name : statementGroupValue.da_name
                newGroup.total_amount = new Intl.NumberFormat('da-DK', {
                  style: 'currency',
                  currency: defaultCurrency,
                }).format(parseFloat(statementGroupValue.totalAmount).toFixed(2))
                newGroup.paid_amount = new Intl.NumberFormat('da-DK', {
                  style: 'currency',
                  currency: defaultCurrency,
                }).format(parseFloat(statementGroupValue.paidAmount).toFixed(2))
                newGroup.rest_amount = new Intl.NumberFormat('da-DK', {
                  style: 'currency',
                  currency: defaultCurrency,
                }).format(parseFloat(statementGroupValue.restAmount).toFixed(2))
                if (typeof statementGroupValue.statements !== 'undefined') {
                  const costDocuments = []
                  Object.values(statementGroupValue.statements).forEach(key => {
                    const objArr = {}
                    if (caseDetails.data.data.statementKeys.includes(key.jobTaskNo)) {
                      objArr.en_name = key.en_name
                      objArr.da_name = key.da_name
                      objArr.category = (i18n.locale === 'en') ? key.en_name : key.da_name
                      objArr.jobTaskNo = key.jobTaskNo
                      // baseDocPaid += parseFloat(key.paidAmount)
                      objArr.total_amount = new Intl.NumberFormat('da-DK', {
                        style: 'currency',
                        currency: defaultCurrency,
                      }).format(parseFloat(key.scheduleTotalPrice).toFixed(2))
                      paymentDocumentsData.push(objArr)
                      objArr.paid_amount = new Intl.NumberFormat('da-DK', {
                        style: 'currency',
                        currency: defaultCurrency,
                      }).format(parseFloat(key.paidAmount).toFixed(2))
                      objArr.rest_amount = key.scheduleTotalPrice - key.paidAmount
                      objArr.rest_amount = new Intl.NumberFormat('da-DK', {
                        style: 'currency',
                        currency: defaultCurrency,
                      }).format(parseFloat(objArr.rest_amount).toFixed(2))
                      costDocuments.push(objArr)
                      if (!statementsKeysRow.includes(key.jobTaskNo)) {
                        statementsKeysRow.push(key.jobTaskNo)
                        this.statementsAmount.push(key)
                      }
                    }
                  })
                  newGroup.costDocuments = costDocuments
                } else if (statementGroupValue.en_name !== 'Sum' || statementGroupValue.da_name !== 'Sum') {
                  const defaultStatementLine = {}
                  defaultStatementLine.en_name = statementGroupValue.en_name
                  defaultStatementLine.da_name = statementGroupValue.da_name
                  defaultStatementLine.jobTaskNo = statementGroupValue.jobTaskNo
                  defaultStatementLine.scheduleTotalPrice = statementGroupValue.totalAmount
                  defaultStatementLine.paidAmount = statementGroupValue.paidAmount
                  this.statementsAmount.push(defaultStatementLine)
                }
                this.statementsData.push(newGroup)
              })
            }
            if (element === 'payments') {
              newObj = caseDetails.data.data[element]
              newObj.forEach(key => {
                const objArr = []
                objArr.id = key.entryNo
                objArr.payment_date = key.dueDate
                objArr.amount = new Intl.NumberFormat('da-DK', { style: 'currency', currency: defaultCurrency }).format(parseFloat(key.Amount).toFixed(2))
                objArr.remaining_amount = new Intl.NumberFormat('da-DK', { style: 'currency', currency: defaultCurrency }).format(parseFloat(key.remainingAmount).toFixed(2))
                objArr.documents = paymentDocumentsData
                this.paymentsData.push(objArr)
              })
            }
          })
        }
        this.loader = false
        this.generalLoader = false
      }
    },
    async taskAction(id, taskId, status) {
      await axios.post(`${constants.baseUrl}/approve-debt-case`, {
        debt_case_id: id,
        status,
        taskId,
      }).then(response => {
        if (response.status === 200) {
          console.log('done', response)
          this.getDetails()
        }
      })
    },
    async getDebtCaseData(item, state) {
      if (state === 'decline') {
        await axios.post(`${constants.baseUrl}/approve-debt-case`, {
          debt_case_id: this.caseDetailsData.id,
          status: 2,
          taskId: this.caseTaskActionData.id,
        }).then(response => {
          if (response.status === 200) {
            console.log('done', response)
          }
        })
        this.bTitle = 'Decline'
        this.bVarient = 'danger'
      }
      if (state === 'terminate') {
        await axios.post(`${constants.baseUrl}/approve-debt-case`, {
          debt_case_id: this.caseDetailsData.id,
          status: 3,
          taskId: this.caseTaskActionData.id,
        }).then(response => {
          if (response.status === 200) {
            console.log('done', response)
          }
        })
        this.bTitle = 'Terminate'
        this.bVarient = 'danger'
      }
      if (state === 'pause') {
        this.bTitle = 'Pause'
        this.bVarient = 'warning'
      }
      if (state === 'resume') {
        this.bTitle = 'Resume'
        this.bVarient = 'primary'
      }
      this.modalLoader = true
      this.showData = { ...item }
      this.selectedState = (state === 'decline') ? 'terminate' : state
      this.modalLoader = false
    },
    async getTerminateData(item, state) {
      if (state === 'terminate') {
        this.caseStateTitle = this.$t('DEBTIA_CASE_TERMINATED_BECAUSE')
      }
      if (state === 'decline') {
        this.caseStateTitle = this.$t('DEBTIA_CASE_DECLINED_BECAUSE')
      }
      this.$refs.terminateModal.$children[0].show()
      this.modalLoader = true
      this.showData = { ...item }
      this.modalLoader = false
    },
    async getClientData(item) {
      this.$refs.clientModal.$children[0].show()
      this.loader = true
      this.showData = item
      this.showData.debt_case_id = this.caseId
      this.loader = false
    },
    async getDebtorData(item) {
      this.$refs.debtorModal[0].$children[0].show()
      this.loader = true
      this.showData = item
      this.loader = false
    },
    async hideDebtorData(item) {
      this.$refs['modal-debtor'].hide()
      this.loader = false
      this.showData = item
      this.loader = true
    },
    async getRepresentativeData(item) {
      this.$refs.representativeModal.$children[0].show()
      this.loader = true
      this.showData = item
      this.showData.debt_case_id = this.caseId
      this.loader = false
    },
    async getCaseLogsData() {
      this.caseId = router.currentRoute.params.id
      this.loader = true
      const caseLogs = await axios.get(`${constants.baseUrl}/get-debt-case-logs/${this.caseId}?perPage=${this.perPage}&q=${this.searchQuery}&page=${this.currentPage}`)
      if (caseLogs.data.status) {
        this.caseLogsData = caseLogs.data.data.data
      }
      this.loader = false
    },
  },
}
</script>

<style lang="scss">

.casedetails-card-body {
  border-bottom: 1px solid #f2f3f3;
}

.right-values{
  float: right;
}

.left-item-padding {
  padding: 0px 20px 0px 0px;
}

.edit-client-btn {
  width: 100%;
  margin-bottom: 10px;
}

.client-details-table {
  width: 100%;
  margin: 10px 0px 10px 0px;
  padding-top: 15px;
  border-top: 1px solid #f2f3f3;
}

.client-addressdetails-table {
  width: 100%;
  margin: 10px 0px 10px 0px;
}

.table-border {
  border-bottom: 1px solid #f2f3f3;
}

// table.child-table td:last-child,
// table.child-table-base td:last-child {
//     padding-right: 0;
// }
// table.child-table td:nth-child(1) {
//     padding-left: 0;
//     width: 0%;
// }
// table.child-table-base td:nth-child(1) {
//     padding-left: 0;
//     width: 15%;
// }
#debt-statements table td, #debt-statements table th {
  width: 25%;
  padding: 0.72rem 1rem;
}
#debt-statements .parent-table th {
  text-align: right;
}
#debt-statements .child-table-base,
#debt-statements .child-table {
  padding-left: 0;
  padding-right: 0;
}

#debt-statements .child-table a {
  font-size: 10px;
}
#debt-statements td[colspan="4"] {
    padding: 0;
}
.text-capitalize {
  text-transform: 'capitalize'
}
.popover {
  min-width: 400px;
}

.pointer-name:hover {
  cursor: pointer;
}

.copy-btn:hover {
  cursor: pointer;
}

.user-action-buttons {
  margin-top: 20px;
}

.user-action-button {
  margin-bottom: 10px;
  width: 100%;
}

.padding-content {
  padding: 10px;
}

.content-heading {
  margin-bottom: 0px !important;
}

.note-content-div {
  display: inline-block; width: 93%; min-height: 38px;
}

.note-font {
  font-size: 14px;
  margin-right: 10px;
}

.notes-alert{
  margin-top: 10px;
}

.representative-div {
  margin-top: 5px;
  padding-top: 5px;
  border-top: 1px solid #d9d9d9;
}

.note-font p{
  margin-bottom: 0px !important;
}

.processcompletedmessage, .processcompletedmessagealert {
  margin-bottom: 0px !important;
}
/* Styles for the icon box */
.b-avatar .b-avatar-custom, .b-avatar .b-avatar-text, .b-avatar .b-avatar-img {
    -webkit-mask-image: none;
    // mask-image: radial-gradient(white, black);
}
.star-icon-box:before {
    content: '';
}
.star-icon-box {
  position: relative;
  // width: 100px;
  // height: 100px;
  // background-color: #f0f0f0;
  // border: 1px solid #ccc;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* Styles for the star */
.star {
  position: absolute;
  top: 0;
  // left: 0;
  left: -7px;
  top: -8px;;
  width: 20px;
  height: 20px;
  background-color: gold;
  clip-path: polygon(
      50% 0%,
      61% 38%,
      100% 38%,
      68% 59%,
      79% 100%,
      50% 75%,
      21% 100%,
      32% 59%,
      0% 38%,
      39% 38%
    );
  }
</style>
